import ApiService from "../api";

export default class GrupoService extends ApiService {

    constructor() {
        super('/api/grupos')
    }

    listarGrupos() {
        return this.get(``)
    }

    buscarGrupo(id) {
        return this.get(`/${id}`)
    }

    cadastrarGrupo(dados) {
        return this.post(``, dados)
    }

    atualizarGrupo(id, dados) {
        return this.put(`/${id}`, dados)
    }

    excluirGrupo(id) {
        return this.delete(`/${id}`)
    }

    adicionarUsuario(id, usuarioId) {
        return this.post(`/${id}/usuarios/${usuarioId}`)
    }

    removerUsuario(id, usuarioId) {
        return this.delete(`/${id}/usuarios/${usuarioId}`)
    }
}
